import {
  FETCH_QUALIFICATIONS,
  FETCH_QUALIFICATIONS_SUCCESS,
  FETCH_QUALIFICATIONS_FAILURE,
  CREATE_QUALIFICATION_REQUEST,
  CREATE_QUALIFICATION_SUCCESS,
  CREATE_QUALIFICATION_FAILURE,
} from "./actionTypes";

// Fetch Qualifications
export const fetchQualifications = (unitId) => ({
  type: FETCH_QUALIFICATIONS,
  payload: { unitId },
});

export const fetchQualificationsSuccess = (qualifications) => ({
  type: FETCH_QUALIFICATIONS_SUCCESS,
  payload: qualifications,
});

export const fetchQualificationsFailure = (error) => ({
  type: FETCH_QUALIFICATIONS_FAILURE,
  payload: error,
});

// Create Qualification
export const createQualification = (formData) => ({
  type: CREATE_QUALIFICATION_REQUEST,
  payload: { formData },
});

export const createQualificationSuccess = (qualification) => ({
  type: CREATE_QUALIFICATION_SUCCESS,
  payload: qualification,
});

export const createQualificationFailure = (error) => ({
  type: CREATE_QUALIFICATION_FAILURE,
  payload: error,
});

